import { Button } from '@mui/material'
import React from 'react'
import InfoIcon from '@mui/icons-material/Info'
import sxs from './_sxs'
import { PlannedConsultationPricesButtonProps } from './_props'

const PlannedConsultationPricesButton: React.FC<PlannedConsultationPricesButtonProps> = ({ ...rest }) => {
    return (
        <Button startIcon={rest.startIcon ?? <InfoIcon />} sx={{ ...sxs.button, ...rest.sx }} {...rest}>
            Voir les tarifs de téléconsultation
        </Button>
    )
}

export default PlannedConsultationPricesButton
